import React, { createContext, useContext, useReducer, useEffect, useState } from "react";

const cartKey = (slug) => `cart_items_${slug || 'default'}`;

const initialState = {
    items: [],
};

function loadInitialState(key) {
    try {
        const saved = localStorage.getItem(key);
        return saved ? { items: JSON.parse(saved) } : initialState;
    } catch {
        return initialState;
    }
}

// 🧠 Редьюсер
function cartReducer(state, action) {
    switch (action.type) {
        case "ADD_ITEM": {
            const existing = state.items.find(item => item.id === action.payload.id);
            if (existing) {
                return {
                    ...state,
                    items: state.items.map(item =>
                        item.id === action.payload.id
                            ? { ...item, quantity: item.quantity + 1 }
                            : item
                    ),
                };
            } else {
                return {
                    ...state,
                    items: [...state.items, { ...action.payload, quantity: 1 }],
                };
            }
        }

        case "REMOVE_ITEM": {
            return {
                ...state,
                items: state.items.filter(item => item.id !== action.payload),
            };
        }

        case "INCREASE_QUANTITY": {
            return {
                ...state,
                items: state.items.map(item =>
                    item.id === action.payload
                        ? { ...item, quantity: item.quantity + 1 }
                        : item
                ),
            };
        }

        case "DECREASE_QUANTITY": {
            return {
                ...state,
                items: state.items
                    .map(item =>
                        item.id === action.payload
                            ? { ...item, quantity: item.quantity - 1 }
                            : item
                    )
                    .filter(item => item.quantity > 0),
            };
        }

        case "CLEAR_CART": {
            return initialState;
        }

        default:
            return state;
    }
}

// 🎯 Контекст
const CartContext = createContext();

// ✅ Провайдер
export const CartProvider = ({ children, initialTableId = null, slug = null }) => {
    const key = cartKey(slug);
    const [state, dispatch] = useReducer(cartReducer, undefined, () => loadInitialState(key));
    const [tableId, setTableId] = useState(initialTableId);
    const [tableName, setTableName] = useState(null);

    useEffect(() => {
        const timer = setTimeout(() => {
            try {
                localStorage.setItem(key, JSON.stringify(state.items));
            } catch {}
        }, 300);
        return () => clearTimeout(timer);
    }, [state.items, key]);

    const addItem = item => dispatch({ type: "ADD_ITEM", payload: item });
    const removeItem = id => dispatch({ type: "REMOVE_ITEM", payload: id });
    const increaseQuantity = id => dispatch({ type: "INCREASE_QUANTITY", payload: id });
    const decreaseQuantity = id => dispatch({ type: "DECREASE_QUANTITY", payload: id });
    const clearCart = () => dispatch({ type: "CLEAR_CART" });

    const totalItems = state.items.reduce((acc, item) => acc + item.quantity, 0);
    const totalPrice = state.items.reduce((acc, item) => acc + item.price * item.quantity, 0);

    return (
        <CartContext.Provider
            value={{
                cartItems: state.items,
                addItem,
                removeItem,
                increaseQuantity,
                decreaseQuantity,
                clearCart,
                totalItems,
                totalPrice,
                tableId,
                tableName,
                setTableId,
                setTableName,
            }}
        >
            {children}
        </CartContext.Provider>
    );
};

// ⚡ Хук
export const useCart = () => useContext(CartContext);
